// Plugin manager (core, generic)
export class CorePluginManager {
  constructor() {
    // Maintain a set of plugins and a simple hook map
    this.plugins = new Set();
    this.hooks = {
      setup: new Set(),
      disconnect: new Set(),
      onErrorCaptured: new Set(),
    };
  }

  register(plugin) {
    this.plugins.add(plugin);
  }

  unregister(plugin) {
    this.plugins.delete(plugin);
  }

  runHooks(hookName, data, client) {
    const hooks = this.hooks[hookName];
    if (!hooks) return data;
    let result = data;
    for (const fn of hooks) {
      try {
        const r = fn(result, client);
        if (r !== undefined) result = r;
      } catch (e) {
        // swallow plugin errors to avoid breaking host app
        console.error('[BugMail] Plugin hook error:', e);
      }
    }
    return result;
  }

  addHook(hookName, fn) {
    if (!this.hooks[hookName]) this.hooks[hookName] = new Set();
    this.hooks[hookName].add(fn);
  }

  removeHook(hookName, fn) {
    this.hooks[hookName]?.delete(fn);
  }
}
